import { useRecoilValue } from "recoil"
import { styled } from "styled-components"
import { langSelector, langState } from "../../../state/langState"
import { T4_en, T4_ko } from "../../../style/constant"
import Service from "./service"

const OnlyTraum = () => {
  const currentLang = useRecoilValue(langState)
  const Text = useRecoilValue(langSelector)

  return(
    <Container>
      <Title currentLang={currentLang}>{Text.onlyTraum.title}</Title>
      <>
        {Text.onlyTraum.service.map((service,idx:number) => 
          <Service 
            idx = {idx} 
            title = {service.title} 
            desc = {service.desc} 
            defaultImg = {service.defaultImg} 
            hoverImg = {service.hoverImg}
            logoImg = {service.logoImg}
          />
          
        )}
      </>
    </Container>
  )
}


export default OnlyTraum

type Props = {
  currentLang: boolean;
}

const Container = styled.section`
  background:#060C17;
  height:2859px;
  display: flex;
  flex-direction: column;
  align-items: center;
`


const Title = styled.h2<Props>`
  margin:178px 0 90px 0;

  ${props => props.currentLang ? 
  `
    ${T4_ko};
  `:
  `
    ${T4_en};
  `
  }
`